import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import './Selector.css'


class Selector extends Component {

  constructor(props) {
    super(props)
    this.onButtonClick = this.onButtonClick.bind(this)
  }
  
  onButtonClick(value) {
    const selectionHandler = this.props.onSelection
    selectionHandler(value)
  }

  render() {
    const items = this.props.items
    const selectedValue = this.props.selectedValue
    const title = this.props.title

    const buttonItems = items.map((item) => 
      <SelectorButton
        key={item.value}
        title={item.title} 
        value={item.value}
        clickHandler={this.onButtonClick}
        selected={item.value === selectedValue}
      /> 
    )

    return (
      <div className={this.props.class}>
        <h4>{title}</h4>
          <Box>
            {buttonItems}
          </Box>
      </div>
    )
  }
}

class SelectorButton extends Component {
  
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
 
  handleClick(e) {
    const clickHandler = this.props.clickHandler
    const value = this.props.value
    clickHandler(value)
  }

  render() {
    const title = this.props.title
    const color = this.props.selected ? "secondary" : "default"
    return (
      <Button variant="outlined" color={color} onClick={this.handleClick} className="selector-button">
        {title}
      </Button>
    )
  }
}

export default Selector;


// WEBPACK FOOTER //
// ./src/Selector.js